import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  path?: string;
}

// 每页独立设置 <title> 与 <meta name="description">，同时刷新 canonical 与 Open Graph
export default function useSeo({ title, description, path }: SeoOptions) {
  useEffect(() => {
    const base = "https://comichunt1.github.io";
    document.title = title;

    const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) upsertMeta("name", "description", description);

    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${base}${path || "/"}`);

    upsertMeta("property", "og:title", title);
    if (description) upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${base}${path || "/"}`);
  }, [title, description, path]);
}